<script setup>
import { computed, ref } from 'vue';
import HeroHeaderSearchPlaceholder from './heroHeaderSearchPlaceholder.vue';
import useProductList from 'shared/components/product/composables/useProductList.js';
import useContentLibrary from 'shared/components/contentLibrary/composables/useContentLibrary.js';

defineProps({
	isMobile: {
		type: Boolean,
		defailt: false
	},
	hasImages: {
		type: Boolean,
		defailt: true
	},
	cssClasses: {
		type: String,
		defailt: ""
	}
});

const displaySearch = computed(() =>
	productListComposable.value.displaySearchOnHero || contentLibraryComposable.value.displaySearchOnHero
);

const productListComposable = ref(null);
const contentLibraryComposable = ref(null);

productListComposable.value = useProductList();
contentLibraryComposable.value = useContentLibrary();


</script>

<template>
	<template v-if="displaySearch">
		<span class="c-hero-header-block__hero-search-wrapper"
				data-testid="hero-header-search-placeholder-wrapper"
				:class="[isMobile ? cssClasses : '', isMobile ? 'hide-on-desktop' : 'hide-on-mobile' , {'c-hero-header-block__hero-search-wrapper--no-media': !hasImages}]"
				>
				<HeroHeaderSearchPlaceholder />
			</span>
	</template>
</template>
